import { gql } from '@apollo/client';

export const fetchLinkedEntitlementsForCollectionOptOutTrial = gql`
  query fetchLinkedEntitlementsForCollectionOptOutTrial(
    $id: String!
    $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!
    $transactionAccountId: String
  ) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      transactionAccountId
      isAddOn
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        id
        entitlementId
        productId
      }
    }
  }
`;
